import { Filter } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

export default function MenuFilter({
  categories,
  selectedCategory,
  onCategoryChange,
  dietaryFilters,
  selectedDietary,
  onDietaryChange
}) {
  const { t, language } = useLanguage();

  return (
    <div className="sticky top-[120px] z-20 bg-cream-50 dark:bg-gray-900 py-4 mb-8">
      <div className="flex flex-col gap-4">
        {/* Category Filter */}
        <div className="overflow-x-auto scrollbar-hide -mx-4 px-4">
          <div className="flex gap-2 min-w-max">
            <button
              onClick={() => onCategoryChange('all')}
              className={`px-4 py-2 rounded-full font-medium text-sm transition-colors whitespace-nowrap ${
                selectedCategory === 'all'
                  ? 'bg-primary-600 text-white'
                  : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
              }`}
            >
              {t('menuPage.all')}
            </button>
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => onCategoryChange(cat.id)}
                className={`px-4 py-2 rounded-full font-medium text-sm transition-colors whitespace-nowrap ${
                  selectedCategory === cat.id
                    ? 'bg-primary-600 text-white'
                    : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
                }`}
              >
                {cat.name[language]}
              </button>
            ))}
          </div>
        </div>

        {/* Dietary Filter */}
        <div className="flex items-center gap-3 flex-wrap">
          <span className="flex items-center gap-1 text-sm text-gray-500 dark:text-gray-400">
            <Filter className="w-4 h-4" />
            {t('menuPage.filterDietary')}:
          </span>
          {dietaryFilters.map((filter) => (
            <button
              key={filter.id}
              onClick={() => onDietaryChange(filter.id)}
              className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors ${
                selectedDietary.includes(filter.id)
                  ? filter.activeClass
                  : 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700'
              }`}
            >
              {filter.label[language]}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
